var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.userInitial)?_c('Badge',_vm._b({},'Badge',_vm.$attrs,false),[_vm._v("\n  "+_vm._s(_vm.userInitial)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }